import { render, staticRenderFns } from "./cancel-about.vue?vue&type=template&id=c3c65142&scoped=true"
import script from "./cancel-about.vue?vue&type=script&lang=js"
export * from "./cancel-about.vue?vue&type=script&lang=js"
import style0 from "./cancel-about.vue?vue&type=style&index=0&id=c3c65142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c65142",
  null
  
)

export default component.exports